import {axios} from ".";
import config from '../config.json';

export const getAllMVO = async () => {
  try{
    const {
      data
    } = await axios.get(`${config.base_url_api}/mvogoal/`);
    return data;
  }catch(error)
  {
    throw new Error(error)
  }
};


export const getMVObyID = async(id) => {
  const {
      data
  } = await axios.get(`${config.base_url_api}/mvogoal/${id}`);
 return data;
};

export const getMVObySDGID = async(id) => {
  const {
      data
  } = await axios.get(`${config.base_url_api}/mvogoal/sdg/${id}`);
 return data;
};

export const getMVObyTargetID = async(id) => {
  const {
      data
  } = await axios.get(`${config.base_url_api}/mvogoal/subsdgid/${id}`);
 return data;
};

export const createMVO = async(data) =>{
  const response =  await axios.post(`${config.base_url_api}/mvogoal/`, data);
  return response;
};

export const updateMVOCharttype = async(mvoID,charttype) =>{
  const response =  await axios.put(`${config.base_url_api}/mvogoal/${mvoID}`, {"charttype": charttype});
  return response;
};
